import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RejectionDto } from '.';




export class RejectionResponseModel extends GlobalResponseObject {
    data?: RejectionDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RejectionDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
